// extracted by mini-css-extract-plugin
export default {"addeventtitleauthorMobil":"AddEventMobilStepTwo_addeventtitleauthorMobil__14vdy"};